module.exports = __webpack_public_path__ + "dimer/static/img/t$eImg2.81cc6e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t$eImg2.jpg
// module id = ob8+
// module chunks = 0